module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.svg?86128b71644abd479cfb452e9ab97d55";